const appEnv = process.env.APP_ENV;

export const CookieNames = Object.freeze({
  ACCESS_TOKEN: `honey-${appEnv}-access-token`,
  REFRESH_TOKEN: `honey-${appEnv}-refresh-token`,
});

export default CookieNames;
